import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger,
          Image,} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-16-bootstrap-date-picker';//has min/maxDate but no time
import Datetime from 'react-datetime';//has time but no min/maxDate
import {ToastContainer, ToastStore} from 'react-toasts';

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import _ from "underscore";
import $ from "jquery";
import moment from 'moment';

//props
//clients
//Facilities
//branches
//facilityLocations - from new table with tour schedules and shit
class TourReport extends Component {
  constructor(props, context) {
      super(props, context);

      this.state = {
        client: "",
        facility: "",
        branch: "",
        schedules: [],//This will come from new table, where rows are guards' filled in schedules.
        filteredSchedules: [],//Change these values, not the data
        selectedSchedules: [],//checked schedules
        dateStart: null,
        dateEnd: null
      }
      this.options = {
          onRowClick: (row) => {  },
          hideSizePerPage: true,
          defaultSortName: 'name',  // default sort column name
          defaultSortOrder: 'asc'  // default sort order
      }
      this.filterSchedules = this.filterSchedules.bind(this);
      this.renderTableCheckBoxes = this.renderTableCheckBoxes.bind(this);
  }

  render() {
    return <Col style={{padding: 30, minHeight: 700, marginTop: 10, marginBottom: 30, marginLeft: 10, marginRight: 10}}>
              {this.renderFilters()}
              {this.renderGraphs()}
              {this.renderTable()}
          </Col>;
  }

  componentDidMount() {
    this.createFakeData();
  }

  renderFilters() {
    var clients = this.props.clients ? this.props.clients : [];
    var facilities = this.props.facilities ? this.props.facilities : [];
    var branches = this.props.branches ? this.props.branches : [];

    return (<div style={{flexDirection: "row", borderBottom: ""/*"thin solid #000000"*/}}>
              <Col>
                <Row>
                  <FormGroup controlId="dateStart"  className="col-md-2"
                                          style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                                          <ControlLabel className="login_label">Select Start Date</ControlLabel>
                                          <Datetime
                                            timeFormat={false}
                                            value={this.state.dateStart}
                                            onChange={(e)=>{
                                              this.setState({dateStart: e})}}/>
                                          </FormGroup>

                  <FormGroup controlId="dateEnd"  className="col-md-2"
                                          style={{textAlign: "center", padding: 5, borderRadius: 5}}>
                                          <ControlLabel className="login_label">Select End Date</ControlLabel>
                                          <Datetime
                                            timeFormat={false}
                                            value={this.state.dateEnd}
                                            onChange={(e)=>{
                                              this.setState({dateEnd: e})}}/>
                                          </FormGroup>

                  <FormGroup controlId="printPDF"  className="col-md-2"
                                          style={{textAlign: "center",  paddingTop: 25, borderRadius: 5, marginLeft: "10%"}}>
                                      <Button className="control-btn blue-btn" block onClick={()=>{ToastStore.warning("Print PDF under construction")}}>

                                          Print PDF
                                      </Button>
                  </FormGroup>

                  <FormGroup controlId="downloadPDF"  className="col-md-2"
                                          style={{textAlign: "center",  paddingTop: 25, borderRadius: 5}}>
                                      <Button className="control-btn dark-blue-btn"  block onClick={()=>{ToastStore.warning("Generate Report in progress")}}>Download PDF</Button>
                  </FormGroup>

                  <FormGroup controlId="generateReport"  className="col-md-2"
                                          style={{textAlign: "center",  paddingTop: 25, borderRadius: 5}}>
                                      <Button className="control-btn green-btn" block disabled={this.state.selectedSchedules.length <= 0} style={{width: "100%"}} onClick={()=>{ToastStore.warning("Generate Report in progress")}}>Generate Report</Button>
                  </FormGroup>
                </Row>
                <Row>

                  <FormGroup controlId="client"  className="col-md-3"
                                          style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                          <ControlLabel className="login_label">Client</ControlLabel>
                          <FormControl componentClass="select"
                                        style={{width: "100%"}}
                                        value={this.state.client ? this.state.client : ""}
                                        onChange={(e)=>{
                                          this.setState({client: e.target.value})
                                        }}>
                                        {clients.length > 0
                                              ? <option value={""}>Any</option>
                                              : <option disabled value={""}>No Options</option> }
                                        {clients.map((choice, index)=>{
                                            if(choice.is_active == 1)
                                              return <option key={index} value={choice.id}>{choice.client_name}</option>
                                          })
                                        }
                          </FormControl>
                  </FormGroup>

                  <FormGroup controlId="facility"  className="col-md-3"
                                          style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                          <ControlLabel className="login_label">Facility</ControlLabel>
                          <FormControl componentClass="select" placeholder="Facility"
                                        style={{width: "100%"}}
                                        value={this.state.facility}
                                        onChange={(e)=>{
                                          this.setState({facility: e.target.value})
                                        }}>
                                        {facilities.length > 0
                                              ? <option value={""}>Any</option>
                                              : <option disabled value={""}>No Options</option> }
                                        {facilities.map((choice, index)=>{
                                            if(choice.is_active == 1)
                                              return <option key={index} value={choice.facility_id}>{choice.facility_name}</option>
                                          })
                                        }
                          </FormControl>
                  </FormGroup>

                  <FormGroup controlId="branch"  className="col-md-3"
                                          style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                          <ControlLabel className="branch_label">Branch</ControlLabel>
                          <FormControl componentClass="select" placeholder="Branch"
                                        style={{width: "100%"}}
                                        value={this.state.branch}
                                        onChange={(e)=>{
                                          this.setState({branch: e.target.value})
                                        }}>
                                        {branches.length > 0
                                              ? <option value={""}>Any</option>
                                              : <option disabled value={""}>No Options</option> }

                                        {branches.length > 0 ?
                                              branches.map((choice, index)=>{
                                                if(choice.is_active == 1)
                                                  return <option key={index} value={choice.id}>{choice.branch_name}</option>
                                              })
                                              :
                                              <option></option>

                                        }
                          </FormControl>
                  </FormGroup>

                  <FormGroup controlId="clearFilter"  className="col-md-2"
                                          style={{textAlign: "center",  paddingTop: 25, borderRadius: 5}}>
                                      <Button className="control-btn blue-btn" block
                                              onClick={()=>{
                                                this.setState({
                                                  client: "",
                                                  facility: "",
                                                  branch: "",
                                                  dateStart: null,
                                                  dateEnd: null,
                                                })
                                              }}>
                                          Clear
                                      </Button>
                  </FormGroup>

                </Row>
                <Row>
                  ** These are just test values. Data for Schedules still in progress. **
                </Row>
              </Col>
           </div>);
  }

  renderTable() {

    return (<div className="tour-report-table">
              <BootstrapTable width="100%" data={ this.filterSchedules()} hover={true} search={true} pagination options={this.options} trClassName={"locationSchedule"}>
                  <TableHeaderColumn width={"auto"} dataFormat={this.renderTableCheckBoxes}></TableHeaderColumn>
                  <TableHeaderColumn width="12%" dataSort={true} dataField='branch'>Branch</TableHeaderColumn>
                  <TableHeaderColumn width="12%" dataSort={true} dataField='facility'>Facility</TableHeaderColumn>
                  <TableHeaderColumn width="12%" dataSort={true} isKey={true} dataField='name'> Location</TableHeaderColumn>
                  <TableHeaderColumn width="60%" dataFormat={this.renderSchedules}>Check In</TableHeaderColumn>
              </BootstrapTable>
          </div>)
  }

  renderGraphs() {

  }

  renderTableCheckBoxes(cell, row, rowIndex, formatExtraData) {
    const rowId = row.id;
    return (<center>
              <FormGroup>
                <Checkbox id={row.id+"_isSelected"} defaultChecked={this.state.selectedSchedules.includes(row)}
                  onChange={()=>{
                    var newSelectedSchedules = this.state.selectedSchedules.slice();

                    if(newSelectedSchedules.includes(row)) {
                      newSelectedSchedules.splice(rowIndex, 1);
                    } else {
                      newSelectedSchedules.push(row);
                    }

                    this.setState({
                      selectedSchedules: newSelectedSchedules.slice()
                    })
                  }}></Checkbox>
              </FormGroup>
            </center>);
  }

  renderSchedules(cell, row, rowIndex, formatExtraData) {

    var text = [];
    row.schedules.map((schedule, i)=>{
      text.push(schedule.time+", ");
      //return <Col key={i} style={{color: schedule.isCompleted ? "green" : "red"}}>{schedule.time}</Col>
    })
    return <Row>
            {row.schedules.map((schedule, i)=>{
              return <div key={i} className="col-md-1" style={{color: schedule.isCompleted ? "green" : "red", minWidth: 70}}>{schedule.time}</div>
            })}
            </Row>;
  }

  createFakeData() {
    var locations = this.props.facilityLocations;
    var schedules = [];

    locations.map((location)=>{
      //Location schedule for 1 day
        schedules.push({name: location.location_name,
                        id: location.facility_location_id,
                        facility: location.facility_name,
                        client: this.getRandomFromListIndex("client_name", this.props.clients),
                        branch: this.getRandomFromListIndex("branch_name", this.props.branches),
                        schedules: this.createFakeSchedules(),
                        isSelected: false})
    });

    if(this.state.filteredSchedules.length <= 0) {
      this.setState({
        schedules: schedules,
        filteredSchedules: schedules
      })
    }
    //return schedules;//{columns: columns, rows: schedules};
  }

  createFakeTime() {
    var timeOfDay = this.getRandomInt(0,2) == 1 ? " AM" : " PM";
    return this.getRandomInt(1,12) + ":" + this.getRandomInt(10, 59) + timeOfDay
  }

  createFakeSchedules() {
      var scheduleCount = this.getRandomInt(3, 10);
      var schedules = [];
      var index = 0;

      while(index < scheduleCount) {
        schedules.push({time: this.createFakeTime(),
                        isCompleted: this.getRandomInt(0,2) == 1 ? true : false});
        index++;
      }

      return schedules;
  }

  filterSchedules() {

    var client = this.state.client;
    var facility = this.state.facility;
    var branch = this.state.branch;
    var isEqualClient = (schedClient) => { return client === schedClient || client == null || client === ""}
    var isEqualBranch = (schedBranch) => { return branch === schedBranch || branch == null || branch === ""}
    var isEqualFacility = (schedFacility) => { return facility === schedFacility || facility == null || facility === ""}
    var isValidDate = (date) => {return (new Date(date) >= new Date(this.state.dateStart) && new Date(date) <= new Date(this.state.dateEnd))}

    return _.filter(this.state.schedules, (schedule) => {
      return isEqualBranch(this.props.getRecnoForName(schedule.branch, "Branch"))
                && isEqualClient(this.props.getRecnoForName(schedule.client, "Client"))
                && isEqualFacility(this.props.getRecnoForName(schedule.facility, "Facility"));
                //&& isValidDate(schedule.date)
    });

  }

  getRandomFromListIndex(field, list) {
    return list[this.getRandomInt(0,list.length)][field];
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

}
export default TourReport;
